// 契約の種類(2022/7時点でフリーとそれ以外の区分しか存在しない)
export const GRADE_TYPE = {
  undefined: -1, // 初期状態
  free: 0, // フリー
  premiere: 1 // フリー以外
} as const
